import { useTracking } from '@change-corgi/core-react/tracking';

import { useTrackOnce } from '#src/app/shared/hooks/tracking';

type Result = ModelHookResult<
	undefined,
	{
		onCtaClick: () => void;
		onSectionView: () => void;
	}
>;

export function useContributeSection(): Result {
	const track = useTracking();
	const trackOnce = useTrackOnce();

	return {
		actions: {
			onCtaClick: () => {
				void track('homepage_membership_page_click');
			},
			onSectionView: () => {
				void trackOnce('homepage_membership_ask_view');
			},
		},
	};
}
